import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative text-stone" }
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = ["tabindex", "data-index"]

import { reactive } from 'vue'
import CircleChevronDown from '@/assets/svg/CircleChevronDown.vue'
import { MenuItem } from './types'

interface Props {
  items: Array<MenuItem>
  selectedIndex: number
  tabindex: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenu',
  props: {
    items: null,
    selectedIndex: null,
    tabindex: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', index: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: Array<MenuItem>
  selectedIndex: number
  tabindex: number
}




const state = reactive({
  isOpen: false,
})

const toggleMenuDisplay = (evt) => {
  state.isOpen = !state.isOpen
}

const handleItemClick = (evt) => {
  let index = parseInt(evt.currentTarget.getAttribute('data-index'))
  if (index != props.selectedIndex) {
    emit('change', index)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["mr-4 transition-opacity", {
        'opacity-0': state.isOpen,
        'opacity-100': !state.isOpen,
      }])
    }, _toDisplayString(props.items[__props.selectedIndex].label), 3),
    _createElementVNode("button", {
      class: "dropdown-menu-btn",
      onClick: toggleMenuDisplay,
      tabindex: props.tabindex
    }, [
      _createVNode(CircleChevronDown, { class: "w-[22px] h-[22px] inline-block" })
    ], 8, _hoisted_2),
    _createElementVNode("ul", {
      class: _normalizeClass(["absolute top-0 right-[38px] text-right transition-opacity bg-slateGray", {
        'opacity-0': !state.isOpen,
        'opacity-100': state.isOpen,
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.value,
          class: _normalizeClass(["px-4", {
          'text-stone': index != props.selectedIndex,
          'text-poppy': index == props.selectedIndex,
        }])
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["dropdown-menu-item underline-offset-4", {
            underline: index == props.selectedIndex,
          }]),
            tabindex: state.isOpen ? props.tabindex + index : -1,
            onClick: handleItemClick,
            "data-index": index
          }, _toDisplayString(item.label), 11, _hoisted_3)
        ], 2))
      }), 128))
    ], 2)
  ]))
}
}

})